import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Clients = () => {
  document.title = "AMAVIE | Application de gestion de Afrika Mobility";
  const [loadingBord, setLoadingBord]=useState(false)
  const [clients, setClients]= useState([])
  const [total, setTotal]=useState(0)
  const [totalPage, setTotalPage]= useState(0)
  const [currPage, setCurrPage]= useState(0)
  const [user, setUser]= useState(null)
  const [search, setSearch]= useState(null)
  const [currAttestation, setCurrAttestation]= useState(null)
  const [modal_detail_beneficiary, setmodal_detail_beneficiary] = useState(false);
  const [modal_beneficiary, setmodal_beneficiary] = useState(false);
  const [errorClient, setErrorClient]= useState(null)
  const [successClient, setSuccessClient]= useState(null)

  //FOR CLIENT FORM
  const [clientLastName, setClientLastName]= useState("")
  const [clientFirstName, setClientFirstName]= useState("")
  const [clientBirthDate, setClientBirthDate]= useState(null)
  const [clientPassport, setClientPassport]= useState(null)
  const [clientPassportExpire, setClientPassportExpire]= useState(null)
  const [genders, setGenders]= useState([{label: "MASCULIN", value: "MALE"}, {label: "FEMININ", value: "FEMALE"}])
  const [clientGender, setClientGender]= useState(null)
  const [clientPhone, setClientPhone]= useState("")
  const [clientEmail, setClientEmail]= useState(null)
  const [clientCountries, setClientCountries]= useState([])
  const [clientNationality, setClientNationality]= useState(null)
  const [clientResidence, setClientResidence]= useState(null)
  
  const checkClientInput = () => {
    if (!clientLastName || !clientLastName.trim()) { setErrorClient('Veuillez entrer le nom du client svp'); return false;}
    if (!clientFirstName || !clientFirstName.trim()) { setErrorClient('Veuillez entrer le prénom du client svp'); return false;}
    if (!clientBirthDate || !clientBirthDate.trim()) { setErrorClient('Veuillez entrer la date de naissance du client svp'); return false;}
    if (!clientPassport || !clientPassport.trim()) { setErrorClient('Veuillez entrer le numéro de passport du client svp'); return false;}
    if (!clientPassportExpire || !clientPassportExpire.trim()) { setErrorClient('Veuillez entrer la date d\'expiration du passport du client svp'); return false;}
    if (!clientGender) { setErrorClient('Veuillez sélectionner le genre du client svp'); return false;}
    if (!clientPhone || !clientPhone.trim()) { setErrorClient('Veuillez entrer le téléphone du client svp'); return false;}
    if (!clientEmail || !clientEmail.trim()) { setErrorClient('Veuillez entrer le mail du client svp'); return false;}
    if (!clientNationality) { setErrorClient('Veuillez sélectionner la nationalité du client svp'); return false;}
    if (!clientResidence) { setErrorClient('Veuillez sélectionner le pays de résidence du client svp'); return false;}
      setErrorClient("")     
      return true;
  };
  const tog_detail_beneficiary = (data) => {
    setCurrAttestation(data)
    setmodal_detail_beneficiary(!modal_detail_beneficiary);
    removeBodyCss();
  };
  const tog_beneficiary = () => { setmodal_beneficiary(!modal_beneficiary); removeBodyCss(); };
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };

  const loadBeneficiaries=(page, search)=> {
    setLoadingBord(true)
    fetch(`${url.BACKEND_URL}/beneficiaries?page=${page}&size=20&search=${search ? search: ""}&company=${JSON.parse(localStorage.getItem("authUser")).company.id}`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      console.log(responseJson);
      
      if (responseJson.status==200) { 
        setClients(responseJson.data)
        // setTotal(responseJson.data.total)
        // setTotalPage(responseJson.data.total_pages, 30)
        // setCurrPage(responseJson.page, 30)
        setLoadingBord(false)
    } else { setClients([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };

  const loadCountries=()=> {
    fetch(url.BACKEND_URL+"/countries", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {         
      if (responseJson.status==200) { 
        setClientCountries(responseJson.data.map(item=>({
          label: item.name,
          value: item.id
        }))); 
      } 
      else { setCountries([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };

  const saveUser= (beneficiary)=>{
    const now = new Date().toISOString();
    const jsonData= JSON.stringify({ company: {id: JSON.parse(localStorage.getItem("authUser")).company.id}, last_name: clientLastName, first_name: clientFirstName, email: clientEmail, phone: clientPhone, password: "012345", beneficiaries: [{id: beneficiary}], roles: [{id: 1}], created_date: now, updated_date: now });
    
    fetch(url.BACKEND_URL+"/users", { method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log("User", responseJson.data);
      if (responseJson.status==200) { 
        setSuccessClient(responseJson.message)
        tog_beneficiary()
      } 
      else { setErrorClient(responseJson.message); }
    }) .catch((error) => { /*setLoader(false);*/ console.log(error); }); 
  }
    
    const processSaveBeneficiary= ()=>{
      const inputError = checkClientInput();
      if (inputError) {
        const now = new Date().toISOString();
        const jsonData= JSON.stringify({ last_name: clientLastName, first_name: clientFirstName, gender: clientGender.value, birth_date: clientBirthDate, phone: clientPhone, email: clientEmail, passport_number: clientPassport, passport_expire: clientPassportExpire, company: {id: JSON.parse(localStorage.getItem("authUser")).company.id}, nationality: {id: clientNationality.value}, residence: {id: clientResidence.value}, created_date: now, updated_date: now });
        console.log(jsonData);
        // setLoader(true)
        fetch(url.BACKEND_URL+"/beneficiaries", { method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log("Beneficiary", responseJson.data);
          if (responseJson.status==200) { 
            setClients([responseJson.data, ...clients]);
            saveUser(responseJson.data.id); 
          }
          else { /* setLoader(false);*/ setErrorClient(responseJson.message) }
        }) .catch((error) => { /* setLoader(false); */ console.log(error); }); 
      }
    }
    
  useEffect(()=>{ loadBeneficiaries(0, null); loadCountries() }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Attestations" />
          <Modal isOpen={modal_beneficiary} toggle={tog_beneficiary} size="lg">
            <ModalHeader className="mt-0" toggle={tog_beneficiary}>Formulaire de création d'un client</ModalHeader>
            <ModalBody>
              <form>
                <Row>
                  <Col lg="3">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Genre</Label>
                      <Select
                        value={clientGender} 
                        isMulti={false}
                        onChange={(selected) => { setClientGender(selected); }}
                        options={genders} 
                        classNamePrefix="select2-selection" 
                        isLoading={false}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label>Nom</Label>
                      <input className="form-control" onChange={(event)=>{ setClientLastName(event.target.value); }}placeholder="Nom du client" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label>Prénoms</Label>
                      <input className="form-control" onChange={(event)=>{ setClientFirstName(event.target.value); }} placeholder="Prénoms du client" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <FormGroup className="form-group mb-3">
                      <Label>Date de naissance</Label>
                      <InputGroup className="">
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Date de naissance"
                          value={clientBirthDate}
                          options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                          onChange={(date, dateStr) => {setClientBirthDate(dateStr);}}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Numéro passport</Label>
                      <input className="form-control" placeholder="Numéro passport" onChange={(event)=>{ setClientPassport(event.target.value); }} type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <FormGroup className="form-group mb-3">
                      <Label>Date d'expiration</Label>
                      <InputGroup className="">
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Date d'expiration"
                          value={clientPassportExpire}
                          options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                          onChange={(date, dateStr) => {setClientPassportExpire(dateStr);}}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <FormGroup className="mb-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="formrow-firstname-input">Numéro de téléphone</label>
                        <PhoneInput
                          defaultCountry="ci"
                          value={clientPhone}
                          onChange={setClientPhone}
                          inputStyle={{ width: "100%" }} 
                          />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Email</Label>
                      <input className="form-control" placeholder="Email du client" onChange={(event)=>{ setClientEmail(event.target.value); }} type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Nationalité</Label>
                      <Select
                        value={clientNationality} 
                        isMulti={false}
                        onChange={(selected) => { setClientNationality(selected); }}
                        options={clientCountries} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Pays de résidence</Label>
                      <Select
                        value={clientResidence} 
                        isMulti={false}
                        onChange={(selected) => { setClientResidence(selected); }}
                        options={clientCountries} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <strong className="text-danger">{errorClient}</strong>
                    <strong className="text-success">{successClient}</strong>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <Button color="primary" style={{ fontSize: 20  }} className="form-control btn btn-primary waves-effect waves-light" onClick={()=>processSaveBeneficiary()}>Ajouter le client</Button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          <Row>
            <CardTitle className="h4">Gestion des clients</CardTitle>
            <Col md={4}>
              <div className="mb-3">
                <Label>Recherche</Label>
                <input className="form-control" placeholder="Rechercher" onChange={(event)=>loadBeneficiaries(0, event.target.value)} type="text" defaultValue="" id="example-datetime-local-input"/>
              </div>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadAttestations(0)}><i className="fas fa-search"></i> Rechercher</Button>
              </div>
            </Col>
            <Col md={3}>
              
            </Col>
             <Col xl={3}>
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Link color="primary" onClick={tog_beneficiary} className="form-control btn btn-warning waves-effect"><i className="fas fa-user-plus"></i> Créer un Client</Link>
              </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {/* <p className="card-title-desc">
                    Use one of two modifier className to make{" "}
                    <code>&lt;thead&gt;</code>s appear light or dark gray.
                  </p> */}

                {/*MODAL POUR VISUALISER L'ATTESTATION*/}
                <Modal isOpen={modal_detail_beneficiary} toggle={tog_detail_beneficiary} size="lg">
                    <ModalHeader className="mt-0" toggle={tog_detail_beneficiary}>Large Modal</ModalHeader>
                    <ModalBody>
                      <p>
                        <strong>
                          {currAttestation?.zone?.name} Heuss
                        </strong>
                      </p>
                      <p>Praesent commodo cursus magna, vel scelerisque
                        nisl consectetur et. Vivamus sagittis lacus vel
                        augue laoreet rutrum faucibus dolor auctor.</p>
                      <p className="mb-0">Aenean lacinia bibendum nulla sed consectetur.
                        Praesent commodo cursus magna, vel scelerisque
                        nisl consectetur et. Donec sed odio dui. Donec
                        ullamcorper nulla non metus auctor
                        fringilla.</p>
                    </ModalBody>
                  </Modal>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 13}}>
                      <thead className="table-light">
                        <tr>
                          <th>Nom et prénoms</th>
                          <th>Contact</th>
                          <th>Email</th>
                          <th>Date de naissance</th>
                          <th>Numéro de passport</th>
                          <th>Expire le</th>
                          <th>Nationalité</th>
                          <th>Résidence</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {clients.map((item, key)=>(
                            <tr>
                              <td>{item?.first_name} {item?.last_name}</td>
                              <td>{item?.phone}</td>
                              <td>{item?.email}</td>
                              <td>{moment(item.birth_date).format("DD-MM-YYYY")}</td>
                              <td>{(item?.passport_number)}</td>
                              <td>{moment(item?.passport_expire).format("DD-MM-YYYY")}</td>
                              <td>{item?.nationality?.name}</td>
                              <td>{item?.residence?.name}</td>
                              {/* <td><a className="fas fa-book" onClick={()=>{setTimeout(() => { tog_detail_beneficiary(item)}, 400);}}></a></td> */}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Clients;
